import 'select2';
import 'select2/dist/css/select2.min.css';
const initBlock = function( $block ) {
	const $variationSelect = $block.find( '.variations .value select' );
	if ( $variationSelect.length && !$variationSelect.hasClass( 'select2-hidden-accessible' ) ) {
		$variationSelect.select2( {
			minimumResultsForSearch: 10,
			dropdownParent: $block.find( '.variations .value' ),
		} );
	}

	const $quantity = $block.find( '.quantity' );
	if ( $quantity.length && !$quantity.find( '.js-decrease' ).length ) {
		$quantity.prepend( '<button class="quantity-btn quantity-btn--decrease svg-icon js-decrease disabled" aria-label="Decrease"></button>' );
		$quantity.append( '<button class="quantity-btn quantity-btn--increase svg-icon js-increase" aria-label="increase"></button>' );

		const $input = $quantity.find( 'input' );
		const $decrease = $quantity.find( '.js-decrease' );
		const $increase = $quantity.find( '.js-increase' );

		$input.on( 'change', function() {
			if ( parseInt( $( this ).val() ) <= 0 || !$( this ).val() ) {
				$( this ).val( 1 );
				$decrease.addClass( 'disabled' );
			} else {
				$decrease.removeClass( 'disabled' );
			}
		} );

		$increase.on( 'click', function( e ) {
			e.preventDefault();
			$input.val( parseInt( $input.val() ) + 1 );
			$decrease.removeClass( 'disabled' );
		} );

		$decrease.on( 'click', function( e ) {
			e.preventDefault();
			if ( parseInt( $input.val() ) > 1 ) {
				$input.val( parseInt( $input.val() ) - 1 );

				if ( parseInt( $input.val() ) === 1 ) {
					$decrease.addClass( 'disabled' );
				}
			}
		} );
	}
};

app.loadBlock( initBlock, 'single-product', '.section-single-product' );

if ( module.hot ) {
	module.hot.accept();
}
